import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class AircraftManeuveringAreaPeriodsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      errors_listing: false,
      errors_messages: [],
      loaded: 0,
      aircraft_id: null,
      location_id: null,
      start_date: null,
      end_date: null,
      aircrafts_select: [],
      locations_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/reboque/aeronave/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ aircrafts_select: responseJson.data.aircrafts_select });
          self.setState({ locations_select: responseJson.data.locations_select });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      aircraft_id: this.state.aircraft_id,
      location_id: this.state.location_id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reboque/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/reboque/aeronave/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        if (responseJson.status === 'warning') {
          self.setState({errors_listing: true, errors_messages: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }
        if (responseJson.status === 'error') {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.titulo}</h3>
      <Link to="/reboque/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{self.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.tituloErro}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.Aeronave}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.placeholder.SelecioneAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.Localidade}:</label>
              <Select
                className="form-field-name"
                name="location_id"
                value={this.state.location_id}
                searchable={true}
                placeholder={this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.SelecioneLocalidade}
                onChange={this.handleSelectChange.bind(this, 'location_id')}
                options={this.state.locations_select}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.Inicio}:</label>
              <InputMask value={this.state.start_date}  maskChar={null} name="start_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'start_date')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.Fim}:</label>
              <InputMask value={this.state.end_date}  maskChar={null} name="end_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'end_date')} placeholder={this.locale.general.diaMesAnoHoraMinuto} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PeriodoReboqueAeronave.AdicionarPeriodoReboqueAeronave.formulario.botaoAdicionarPeriodoReboque}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftManeuveringAreaPeriodsAdd;



// WEBPACK FOOTER //
// ./src/Components/AircraftManeuveringAreaPeriods/AircraftManeuveringAreaPeriodsAdd.js